import { useEffect } from "react";
import { FormattedMessage as FM } from "react-intl";
import { signal } from "@preact/signals-react";

import proxy from "api/proxy";
import Divider from "components/MeForm/Divider";
import bagaggeImg from "./storage/bagagge.png";
import photo1 from "./storage/photo-spa.png";
import photo2 from "./storage/photo-tour.png";
import photo3 from "./storage/photo-rest.png";
import GalleryItem from "components/Tools/GalleryItem";

const servicesImgs = [photo1, photo2, photo3];
const dataExperiences = signal(servicesImgs);

function SuccessPage() {
  window.scrollTo(0, 0);

  const getExperiences = async () => {
    const { data: fields_names } = await proxy.getFields("sale.shop", []);
    console.log(fields_names, "fields_names");
    let existField = fields_names["experiences"] ? true : false;
    if (existField) {
      const dom = [];
      const fields = [
        "id",
        "experiences.images",
        "experiences.images.image_url",
      ];
      const { data: dataExp } = await proxy.search("sale.shop", dom, fields);
      if (dataExp) {
        const imageUrls = dataExp.flatMap(
          (item) =>
            item["experiences."]?.flatMap((experience) =>
              experience["images."]
                ? experience["images."].map((img) => img.image_url)
                : [],
            ) || [],
        );
        console.log(imageUrls);
        if (imageUrls.length > 0) {
          dataExperiences.value = imageUrls;
          console.log(dataExperiences.value);
        }
      }
    }
  };

  const ImageExp = ({ data }) => {
    return (
      <figure className="shadow-md cursor-move">
        <img
          src={data}
          className="md:max-w-full h-56 md:min-h-[50vh] rounded-md max-w-full object-cover shadow-xl "
        />
      </figure>
    );
  };

  useEffect(() => {
    getExperiences();
  }, []);

  const carouselProps = {
    // autoplay: true,
  };
  return (
    <div className="block px-6 text-center">
      <img width={110} src={bagaggeImg} className="mx-auto" />
      <h1 className="mt-8 text-slate-600 text-center text-3xl font-bold">
        <FM id="webcheckin_success_header" name="webcheckin_success_header" />
      </h1>
      <div className="my-6">
        <p className="text-lg text-slate-700">
          <FM id="webcheckin_success_msg" name="webcheckin_success_msg" />
        </p>
      </div>
      <Divider />
      <div className="my-6 text-center">
        <h1 className="text-3xl text-cyan-600">
          <FM
            id="webcheckin_success_our_services"
            name="webcheckin_success_our_services"
          />
        </h1>
      </div>
      <div className="mb-12">
        <GalleryItem
          data={dataExperiences.value}
          renderItemComponent={<ImageExp />}
          numberItem={{ desk: 3, mobile: 3 }}
          mode="default"
          style="grid grid-cols-1 md:grid-cols-3 h-full shadow-md
          "
          indicator={true}
        />
      </div>
    </div>
  );
}

export default SuccessPage;
